import * as React from 'react';
import ReduxToastr from 'react-redux-toastr';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import { AuthUtils } from 'helpers/AuthUtils';
import { AppScope } from 'store/constant';
import AdminActions from './routes/Admin';
import TenantActions from './routes/Tenant';
import ForClientPortalRoutesComponent from './routes/ClientPortal';
import clsx from 'clsx';

class MainAppComponent extends React.Component<{
  isLoggedIn?: boolean;
}> {
  render() {
    const scope: AppScope = AuthUtils.getAppScope();
    return (
      <div className={clsx(AuthUtils.isClientPortal() && 'client-portal-wrapper')}>
        {scope === AppScope.superadmin ? <AdminActions /> : null}
        {scope === AppScope.tenant ? <TenantActions /> : null}
        {scope === AppScope.clientportal ? <ForClientPortalRoutesComponent /> : null}
        <ReduxToastr
          timeOut={4000}
          newestOnTop={false}
          preventDuplicates={true}
          position="top-center"
          transitionIn="fadeIn"
          transitionOut="fadeOut"
          progressBar={false}
        />
      </div>
    );
  }
}

export default MainAppComponent;
